// extracted by mini-css-extract-plugin
export default {"container":"ImgZoomCard_container__dwzJC","card":"ImgZoomCard_card__mFHj4"};